import React, {ReactElement} from 'react';
import Checkbox from '@material-ui/core/Checkbox';

// FIXME: create interface.
const CheckBoxField = (props: any): ReactElement => {
  return <Checkbox color="primary" {...props} style={{padding: 0}} />;
};
export default CheckBoxField;
